module.exports = __webpack_public_path__ + "img/2.80aa2eaa.jpg";